<template>
  <div id="app" class="wrapper">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="cart">
        <br />
        <h1 class="title cor-preta">Meus dados</h1>
        <div
          v-if="
            possuiRaio === '1' &&
            (tipoEntrega === '2' || tipoEntrega === '3' || tipoEntrega === '4')
          "
          class="modal-body"
        >
          <!--<form v-for="nome_ordem of nome_ordens" :key="nome_ordem.cd">-->
          <form>
            <div
              style="display: flex; flex-direction: column"
              class="col-md-14"
            >
              <div class="form-group">
                <label class="col-md-4 control-label" for="cidade">
                  CEP :
                </label>

                <div class="input-cep col-md-10">
                  <input
                    style="width: 100%"
                    type="text"
                    class="form-control"
                    v-model="cep"
                    id="cep"
                    name="cep"
                    placeholder="Insira o CEP de entrega. Ex: 12345678"
                  />
                  <button
                    type="button"
                    @click="procurarCep"
                    class="botao-cep btn btn-dark"
                    style="
                      color: #fff;
                      border-color: #343a40;
                      background-color: #006400;
                    "
                  >
                    Procurar CEP
                  </button>
                </div>

                <div style="margin: 0.5em 1em" v-if="estado == ''">
                  <button @click="abrirPopUp" class="busca-endereco">
                    <label>Não sabe o seu CEP?</label>
                  </button>
                </div>

                <div class="text-center">
                  <button
                    class="btn btn-primary"
                    type="button"
                    v-if="carregandoCep"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Carregando...
                  </button>
                </div>
              </div>

              <div class="form-group estilo-form" v-if="estado != ''">
                <label class="col-md-4 control-label" for="estado"
                  ><strong>Estado :</strong> {{ estado }}
                </label>
              </div>

              <div class="form-group estilo-form" v-if="cidade.nm != ''">
                <label class="col-md-4 control-label" for="cidade"
                  ><strong>Cidade :</strong> {{ cidade.nm }}
                </label>
              </div>

              <div class="form-group estilo-form" v-if="bairro.nm != ''">
                <label class="col-md-4 control-label" for="bairro"
                  ><strong>Bairro :</strong> {{ bairro.nm }}
                </label>
                <!-- <div class="col-md-10">
                  <div
                    id="taxa"
                    name="taxa"
                    v-if="bairro.nm != ''"
                  >
                    <div>Taxa de entrega : R${{ bairro.taxa }}</div>
                  </div>
                </div> -->
              </div>

              <div class="form-group estilo-form" v-if="rua != ''">
                <label class="col-md-4 control-label" for="rua"
                  ><strong>Rua :</strong> {{ rua }}
                </label>
              </div>

              <div class="form-group" v-if="estado != ''">
                <label class="col-md-4 control-label" for="complemento"
                  >Complemento :
                </label>
                <div class="col-md-10">
                  <input
                    type="text"
                    id="complemento"
                    name="complemento"
                    v-model="complemento"
                    placeholder="Complemento"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>

              <div class="form-group" v-if="estado != ''">
                <label class="col-md-4 control-label" for="numero"
                  >Número :
                </label>
                <div class="col-md-10">
                  <input
                    type="number"
                    id="numero"
                    name="numero"
                    v-model="numero"
                    placeholder="Número"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>

              <div class="form-group" v-if="estado != ''">
                <label class="col-md-4 control-label" for="referencia"
                  >Referência :
                </label>
                <div class="col-md-10">
                  <input
                    type="text"
                    id="referencia"
                    name="referencia"
                    v-model="referencia"
                    placeholder="Referência"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <span
          v-else-if="tipoEntrega === ''"
          class="spinner-border"
          role="status"
          aria-hidden="true"
        ></span>
        <div v-else class="modal-body">
          <!--<form v-for="nome_ordem of nome_ordens" :key="nome_ordem.cd">-->
          <form>
            <div class="col-md-14">
              <div class="form-group">
                <label class="col-md-4 control-label" for="estado"
                  >Estado :
                </label>
                <div class="col-md-10">
                  <!--<input type="text" id="estado" name="estado" v-model="estado" placeholder="Estado" class="form-control input-md" required="required">-->
                  <select
                    class="form-control"
                    id="estado"
                    name="estado"
                    v-model="estado"
                  >
                    <option value="">Selecione o Estado (UF)</option>
                    <option v-for="(estado, idx) of estados" :key="idx">
                      {{ estado.uf }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="cidade"
                  >Cidade :
                </label>
                <div class="col-md-10">
                  <select
                    class="form-control"
                    id="cidade"
                    name="cidade"
                    v-model="cidade"
                    @change="getBairros(cidade.ibge)"
                  >
                    <option :value="cid" v-for="cid of cidades" :key="cid.cd">
                      {{ cid.nm }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group" v-if="cidade.nm != ''">
                <label class="col-md-4 control-label" for="estado"
                  >Bairro :
                </label>
                <div class="col-md-10">
                  <select
                    class="form-control"
                    id="bairro"
                    name="bairro"
                    v-model="bairro"
                  >
                    <option :value="bai" v-for="bai of bairros" :key="bai.cd">
                      {{ bai.nm }}
                    </option>
                  </select>
                  <div
                    style="margin: 5px"
                    id="taxa"
                    name="taxa"
                    v-if="bairro.nm != ''"
                  >
                    <div>
                      Taxa de entrega: R${{ Number(bairro.taxa).toFixed(2) }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="rua">Rua : </label>
                <div class="col-md-10">
                  <input
                    type="text"
                    id="rua"
                    name="rua"
                    v-model="rua"
                    placeholder="Rua"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="numero"
                  >Número :
                </label>
                <div class="col-md-10">
                  <input
                    type="number"
                    id="numero"
                    name="numero"
                    v-model="numero"
                    placeholder="Número"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="complemento"
                  >Complemento :
                </label>
                <div class="col-md-10">
                  <input
                    type="text"
                    id="complemento"
                    name="complemento"
                    v-model="complemento"
                    placeholder="Complemento"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label" for="referencia"
                  >Referência :
                </label>
                <div class="col-md-10">
                  <input
                    type="text"
                    id="referencia"
                    name="referencia"
                    v-model="referencia"
                    placeholder="Referência"
                    class="form-control input-md"
                    required="required"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer" v-if="estado != ''">
          <button
            style="
              color: #fff;
              border-color: #343a40;
              background-color: #006400;
            "
            type="button"
            class="btn btn-dark"
            @click="cadastrarEndereco()"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.busca-endereco {
  display: inline-block;
  padding: 0.5em 1em;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.form-control {
  padding: 0.25rem 0.25rem !important;
}
</style>
<script>
import { mapGetters } from "vuex";
import Estado from "../services/estado";
import Endereco from "../services/endereco";
import Bairro from "../services/bairro";
import Cidade from "../services/cidade";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import cidade from "../services/cidade";
import axios from "axios";

export default {
  name: "Endereco",
  data() {
    return {
      msgEntrega: "",
      msgRetirada: "",
      msgBuscaFone: "",
      email: "",
      senha: "",
      nomecompleto: "",
      telefone: "",
      estado: "",
      cidade: {
        uf: "",
        nm: "",
        qtd_estab: "",
        ibge: "",
        dt_replica: "",
        hash: "",
      },
      bairro: {
        cd: "",
        nm: "",
        ibge: "",
        taxa: "",
        ativo: "",
        dt_replica: "",
      },
      rua: "",
      numero: "",
      complemento: "",
      referencia: "",
      ibge: "",
      inis_valores: [],
      inis_valor: [],
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      vendaspedidos: [],
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
      },
      bairroCidade: [],
      listarendereco: false,
      bairros: "",
      cidades: "",
      estados: "",
      listaAdicionais: "",
      cep: "",
      latitude: "",
      longitude: "",
      tipoEntrga: "",
      carregandoCep: "",
      possuiRaio: "",
      tipoEntrega: "",
      somenteRetirada: false,
    };
  },
  computed: {
    ...mapGetters({
      //adicionais: 'allAdicionais',
      logado: "retornaLogado",
    }),
  },
  methods: {
    //listarinis
    async listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis_valor = resposta.data;
      });
      await Inis.listarInisCd("POSSUI_RAIO").then((resposta) => {
        this.possuiRaio = resposta.data[0].vl;
      });
      await Inis.listarInisCd("TIPO_ENTREGA").then((resposta) => {
        this.tipoEntrega = resposta.data[0].vl;
      });
      await Inis.listarInisCd("SOMENTE_RETIRADA").then((resposta) => {
        this.somenteRetirada = resposta.data[0].vl === "1";
      });
    },
    async abrirPopUp() {
      try {
        const { value: logradouro } = await Swal.fire({
          title: "Qual é a sua rua?",
          input: "text",
          inputPlaceholder: "Digite o nome da sua rua",
          inputValidator: (value) => {
            if (!value) return "Por favor insira o nome da sua rua!";
          },
        });

        if (!logradouro) return;

        const { value: cidade } = await Swal.fire({
          title: "Qual é a sua cidade?",
          input: "text",
          inputPlaceholder: "Digite o nome da sua cidade",
          inputValidator: (value) => {
            if (!value) return "Por favor insira a cidade!";
          },
        });

        if (!cidade) return;

        const { value: uf } = await Swal.fire({
          title: "Qual é o estado (UF)?",
          input: "text",
          inputPlaceholder: "Digite a sigla do estado (ex: SC)",
          inputValidator: (value) => {
            if (!value || value.length !== 2)
              return "Digite a UF com 2 letras.";
          },
        });

        if (!uf) return;

        const dados = {
          id: "pesquisa_endereco_por_uf_cidade",
          params: {
            from: 0,
            size: 10,
            query_string: logradouro,
            cidade: cidade,
            uf: uf,
          },
        };
        const endereco = await this.buscarEndereco(dados);

        if (!endereco) {
          Swal.fire({
            title: "Erro",
            text: `Não foi possível encontrar informações para a rua informada. ${dados.params.query_string} em ${dados.params.cidade}/${dados.params.uf}.`,
            icon: "error",
          });
          return;
        }

        const { isConfirmed } = await Swal.fire({
          title: "Esta é sua localização?",
          html: `
            <strong>Rua:</strong> ${endereco.logradouro} <br>
            <strong>Bairro:</strong> ${endereco.bairro} <br>
            <strong>Cidade:</strong> ${endereco.cidade} <br>
            <strong>Estado:</strong> ${endereco.estado} <br>
            <strong>CEP:</strong> ${endereco.cep}
          `,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        });

        if (isConfirmed) {
          Swal.fire({
            title: "Ótimo!",
            text: "Localização confirmada com sucesso.",
            icon: "success",
          });

          this.cep = endereco.cep;
          await this.procurarCep();
        } else {
          Swal.fire({
            title: "Ops!",
            text: "Tente informar outra rua ou revise os dados.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Erro no fluxo:", error);
        Swal.fire({
          title: "Erro!",
          text: "Algo deu errado, tente novamente.",
          icon: "error",
        });
      }
    },
    async buscarEndereco(dados) {
      try {
        const response = await axios.post(
          `https://panterafood-a6be668f1a6b4c5c.api.findcep.com/v1/endereco/template/uf/cidade`,
          dados,
          {
            headers: {
              Referer: "E331DRRF15B7E8",
            },
          }
        );
        const resultados = response.data?.hits?.hits;

        if (!Array.isArray(resultados) || resultados.length === 0) {
          console.warn(
            "Nenhum resultado encontrado para os parâmetros fornecidos."
          );
          return null;
        }

        const data = resultados[0]._source;

        return {
          logradouro: data.logradouro || "",
          bairro: data.bairro || "",
          cidade: data.cidade || "",
          estado: data.uf || "",
          cep: data.cep || "",
        };
      } catch (error) {
        console.error(
          "Erro ao buscar endereço:",
          error.response?.data || error.message
        );
        return null;
      }
    },
    listandoCidade() {
      Cidade.listandoCidade().then((resposta) => {
        this.cidades = resposta.data;
        // alert(JSON.stringify(this.cidades));
      });
    },
    listandoEstado() {
      Estado.listandoEstado().then((resposta) => {
        this.estados = resposta.data;
        // alert(JSON.stringify(this.cidades));
      });
    },
    returnIBGE(ibge) {
      this.ibge = ibge;
    },

    async procurarCep() {
      if (this.cep.length != 8) {
        Swal.fire({
          title: "Erro!",
          text: "O Cep foi inserido incorretamente, verifique de novo!",
          icon: "error",
        });
      } else {
        try {
          this.carregandoCep = true;

          const response = await axios.get(
            `https://panterafood-a6be668f1a6b4c5c.api.findcep.com/v1/cep/${this.cep}.json`,
            {
              headers: {
                Referer: "E331DRRF15B7E8",
              },
            }
          );

          const data = response.data;
          this.validaEnderecoDeEntrega(data);
          this.carregandoCep = false;

          await this.procuraLatLon();
        } catch (error) {
          console.error(
            "Não foi possível encontrar a rua para esse CEP: ",
            error
          );
        }
      }
    },

    async validaEnderecoDeEntrega(data) {
      if (
        this.possuiRaio === "1" &&
        (this.tipoEntrega === "2" ||
          this.tipoEntrega === "3" ||
          this.tipoEntrega === "4")
      ) {
        this.rua = data.logradouro;
        this.estado = data.uf;
        this.cidade.nm = data.cidade;
        this.bairro.nm = data.bairro;
      } else {
        Bairro.listandoBairro(data.codigo_ibge).then((response) => {
          if (!response.data[0]) {
            Swal.fire({
              title: "Bairro não encontrado",
              confirmButtonColor: "#000000",
            });
          } else {
            this.rua = data.logradouro;
            this.estado = data.uf;
            this.cidade.nm = data.cidade;
            this.bairro.nm = data.bairro;

            // this.bairro.taxa = response.data[0].taxa
          }
        });
      }
    },

    async procuraLatLon() {
      try {
        const response = await axios.get(
          `https://panterafood-a6be668f1a6b4c5c.api.findcep.com/v1/geolocation/cep/${this.cep}`,
          {
            headers: {
              Referer: "E331DRRF15B7E8",
            },
          }
        );

        const data = response.data;
        await this.insereLatLon(data);
      } catch (error) {
        console.error(
          "Não foi possível encontrar a geolocalização deste CEP: ",
          error
        );
      }
    },

    async insereLatLon(data) {
      if (data && data.location && data.location.lat && data.location.lon) {
        this.latitude = data.location.lat;
        this.longitude = data.location.lon;
      } else {
        Swal.fire({
          title: "LatLon não encontrado",
          confirmButtonColor: "#000000",
        });
      }
    },

    async cadastrarEndereco() {
      if (this.estado == "") {
        Swal.fire({
          title: "Escolha um estado",
          confirmButtonColor: "#000000",
        });
      } else if (this.cidade.nm == "") {
        Swal.fire({
          title: "Escolha uma cidade",
          confirmButtonColor: "#000000",
        });
      } else if (this.bairro.nm == "") {
        Swal.fire({
          title: "Escolha uma bairro",
          confirmButtonColor: "#000000",
        });
      } else if (this.rua == "") {
        Swal.fire({
          title: "Digite sua rua",
          confirmButtonColor: "#000000",
        });
      } else if (this.numero == "") {
        Swal.fire({
          title: "Digite seu número de endereço",
          confirmButtonColor: "#000000",
        });
      } else {
        var e = new Object();
        e.estado = this.estado;
        e.cidade = this.cidade.nm;
        e.bairro = this.bairro.nm;
        e.rua = this.rua + ", n" + this.numero;
        e.cep = this.cep;
        e.complemento = this.complemento;
        e.referencia = this.referencia;
        e.ibge = this.ibge;
        e.cd = localStorage.getItem("cd" + localStorage.getItem("contrato"));
        if (
          this.possuiRaio === "1" &&
          (this.tipoEntrega === "2" ||
            this.tipoEntrega === "3" ||
            this.tipoEntrega === "4")
        ) {
          e.latitude = Number(this.latitude).toFixed(7);
          e.longitude = Number(this.longitude).toFixed(7);
        }

        await Endereco.cadastrarendereco(e).then(function (response) {
          Swal.fire({
            title: response.data,
            confirmButtonColor: "#000000",
          });
        });

        this.$router.push("/finalizadoLogin");
      }
    },
    getBairros(cidade) {
      Bairro.listandoBairro(cidade).then((response) => {
        this.bairros = response.data.map((bairro) => {
          // bairro.taxa = parseFloat(bairro.taxa).toFixed(2);
          return bairro;
        });
      });
    },
    verificaLogado() {
      if (this.logado == false) {
        this.$router.push("/login");
      }
    },
    verificaRetirada() {
      if (this.somenteRetirada) {
        this.$router.push("/finalizadologin");
      }
    },
  },
  async mounted() {
    this.verificaLogado();
    await this.listarinis();
    this.verificaRetirada();
    this.listandoCidade(), this.listandoEstado();
  },
};
</script>

<style>
.input-cep {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.estilo-form {
  display: inline;
  width: 50%;
  padding: 0.25em;
  margin-left: 1.15em;
  font-size: 1rem;
  line-height: 1.25;
  color: #495057;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
</style>
